<template>
  <div id="app">
    <!-- <flash-message class="myCustomClass"></flash-message> -->
    <transition name="page">
      <router-view/>
    </transition>
    <!-- <foot-component/> -->
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted: function() {
    console.log("Main app loaded");
  }
}
</script>
<style lang="scss">
   @import './scss/main.scss';
</style>
